import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function SenderCityField(props) {
    return (
        <FormikInput
            name={'senderCity'}
            label={'shippingMethods.form.field.senderCity.label'}
            placeholder={'shippingMethods.form.field.senderCity.placeholder'}
            required={true}
        />
    );
}

export default SenderCityField;
